<template>
  <q-search
    ref="search"
    inverted-light
    class="search-input"
    color="transparent"
    v-model="search"
    :placeholder="placeholder"
    v-shortkey="{ lower: ['f'], upper: ['shift', 'f'] }"
    @shortkey.native="focusSearch"
  >
    <q-autocomplete
      ref="autocomplete"
      :debounce="defaultSearchDebounce"
      :min-characters="0"
      @search="handleSearch"
      @selected="selected"
      :value-field="() => search"
    />
  </q-search>
</template>

<script>
  import { SearchClient } from 'src/api/Search'
  import debounceMixin from 'src/utils/mixins/debounce'
  import { mapSearchResult } from 'src/utils/searchResultParser'

  export default {
    data () {
      return {
        search: null
      }
    },

    computed: {
      placeholder () {
        return this.$q.platform.is.mobile ? this.$t('toolbar_search_mobile') : this.$t('toolbar_search')
      }
    },

    methods: {
      focusSearch () {
        this.$refs.search.focus()
      },

      handleSearch (term, done) {
        this.executeSearch(term)
          .then(response => {
            done(response.data.data.map(mapSearchResult))
          })
      },

      executeSearch (term) {
        const client = new SearchClient()
          .limit(6)
          .include(['customer', 'company'])

        if (!term) {
          return client.suggest()
        }

        return client.search(term)
      },

      selected (data, keyboard) {
        // If event triggered by keyboard do not redirect,
        // otherwise the arrow keys do not work as intended
        if (keyboard) {
          return
        }

        this.search = null
        this.$refs.search.blur()
        this.$refs.autocomplete.hide()

        const model = data.value

        switch (model.search_type) {
        case 'customer':
          this.$router.push({
            name: 'customer',
            params: {
              customerId: model.type === 'contact_person'
                ? model.company_id
                : model.id,
              teamId: model.team_id
            }
          })
          break
        case 'invoice':
          if (model.status === 'draft') {
            this.$router.push({ name: 'edit-invoice', params: { invoice: model.id, teamId: model.team_id } })
          } else {
            this.$router.push({ name: 'invoice', params: { invoice: model.id, teamId: model.team_id } })
          }
          break
        case 'quote':
          if (model.status === 'draft') {
            this.$router.push({ name: 'edit-quote', params: { quote: model.id, teamId: model.team_id } })
          } else {
            this.$router.push({ name: 'quote', params: { quote: model.id, teamId: model.team_id } })
          }
          break
        case 'project':
          this.$router.push({ name: 'project', params: { project: model.id, teamId: model.team_id } })
          break
        case 'item':
        case 'recurring_invoice':
          this.$q.notify({ message: 'Not implemented', type: 'negative' })
        }
      }
    },

    mixins: [
      debounceMixin
    ]
  }
</script>

<style lang="stylus">
  @import '~variables'

  .search-input
    box-shadow: none !important
    color: $grey-9 !important
    > .q-icon
      color: $grey-6
</style>
